import { render, staticRenderFns } from "./RefControl.vue?vue&type=template&id=19c5156c&scoped=true&"
import script from "./RefControl.vue?vue&type=script&lang=js&"
export * from "./RefControl.vue?vue&type=script&lang=js&"
import style0 from "./RefControl.vue?vue&type=style&index=0&id=19c5156c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c5156c",
  null
  
)

export default component.exports